import type { IconData } from '@stacksjs/iconify-core'

export const cakeSliceSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22 14a6 6 0 0 1 4.438-5.795C26.098 6.073 24.394 4.5 22 4.5a1.5 1.5 0 0 1 0-3c4.119 0 7.077 2.953 7.458 6.678A6 6 0 1 1 22 14m15 0a9 9 0 0 1-17.915 1.235l-.423.181c-3.227 1.39-6.42 2.947-9.187 4.56c-2.746 1.6-5.16 3.307-6.76 5.02q-.224.241-.404.504h44.147c-.434-7.475-4.046-12.118-6.19-14.235a5.22 5.22 0 0 0-4.312-1.478A8.96 8.96 0 0 1 37 14m9.497 14.5H1.506c.015 2.514.069 4.667.144 6.5h44.702c.076-1.833.13-3.986.145-6.5M1.808 38c.097 1.475.205 2.65.309 3.567c.262 2.325 2.09 4.014 4.353 4.236c3.057.298 8.774.697 17.52.697c8.75 0 14.479-.4 17.541-.698c2.264-.22 4.093-1.91 4.355-4.237c.103-.917.212-2.091.308-3.565z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default cakeSliceSolid
